import { combineReducers } from 'redux';
import appReducer from './appReducer';

export default combineReducers({
  app: appReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js